import {LocalizationManager} from '../../bower_components/jwf-localization/dist/jwf.localization.core';
import ParamStore from '../logic/stores/param-store';
import AjaxUrl from '../constants/ajax-url';
import UiStateStore from '../logic/stores/ui-state-store';

import '../resources/localization/de-de.json';
import '../resources/localization/en-us.json';
import '../resources/localization/es-es.json';
import '../resources/localization/fr-fr.json';
import '../resources/localization/it-it.json';
import '../resources/localization/nl-nl.json';
import '../resources/localization/pt-br.json';

class LocalizationFactory {
    constructor() {
        this.localizationManager = null;
        this.localize = this.localize.bind(this);
        this.initLocalization = this.initLocalization.bind(this);
        this.componentId = 0;
    }

    initLocalization(componentId) {
        this.componentId = componentId;
        const localizationConfig = {
            config: {
                defaultCulture: 'en-us',
                currentCulture: ParamStore.getModel(this.componentId).lang5.toLowerCase(),
                loadResources: true,
                resourcePath: AjaxUrl.localization.resource.url.replace('{rootUrl}', ParamStore.getModel(this.componentId).rootUrl)
            }
        };

        this.localizationManager = new LocalizationManager(
            localizationConfig,
            function(url) {
                return fetch(url).then((response) => {
                    return new Promise((resolve, reject) => {
                        if (response.status !== 200) {
                            reject(response);
                        }
                        resolve(response.json())
                    })
                });
            }
        );

        return this.localizationManager.loadPromise;
    }

    localize() {
        var overrideNodeIdRepresentation = (ParamStore.getModel(this.componentId).lang5 + '.' + arguments[0]).toLowerCase(),
            overrideNodeValue;

        UiStateStore.getModel(this.componentId).form.localizationOverrides.map((override) => {
            if (Object.keys(override)[0].toLowerCase() === overrideNodeIdRepresentation) {
                overrideNodeValue = override[overrideNodeIdRepresentation];
            }
        });

        if (overrideNodeValue) {
            return overrideNodeValue;
        }

        return this.localizationManager.getString.apply(this.localizationManager, arguments)
    }
}

const localizationFactory = new LocalizationFactory();

export default localizationFactory;
export const localize = localizationFactory.localize;



/** WEBPACK FOOTER **
 ** ./src/infrastructure/localization.js
 **/